export const DROPDOWN_NOTIFICATION_LIMITS = {
  title: 60,
  body: 120,
};

export const ALL_NOTIFICATIONS_LIMITS = {
  title: 80,
  body: 220,
};

export const truncateWithEllipsis = (text, maxLength) => {
  if (typeof text !== "string") return "";
  if (typeof maxLength !== "number" || maxLength <= 0) return text;

  return text.length > maxLength ? `${text.slice(0, maxLength).trimEnd()}…` : text;
};
